import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PrinterSetupService extends Service {
  @tracked showPrinterSelectorDialog = false;

  #callback;

  /**
   * @param {string} printerValue - either printer name (LOCAL mode) or printing target id (REMOTE mode)
   * @param {'LOCAL' | 'REMOTE'} mode
   */
  onSelect(printerValue, mode = 'LOCAL') {
    this.showPrinterSelectorDialog = false;
    this.#callback?.({ printerValue, mode });
  }

  async selectReceiptPrinter() {
    this.showPrinterSelectorDialog = true;
    return new Promise((resolve) => {
      this.#callback = resolve;
    });
  }
}
